// Pure visibility predicates for the welcome coupon prompt. Extracted so the
// business gate is unit-testable and can't silently regress.
//
// Visibility is driven by the server-computed `claimable` flag
// (welcomeCouponClaimable), which already encodes enabled + positive amount +
// per-viewer eligibility: logged-out viewers are always claimable (registration
// CTA); logged-in viewers are claimable only when an eligible student who has
// neither claimed nor purchased and is not the team owner/member. The only
// client-side gate left is `suppressed` (the prompt's own login modal, used by
// the logged-out registration flow).

// Steady-state visibility — ignores `suppressed`. Drives the once-per-page-view
// impression so opening/closing the login modal does not re-fire it.
export function couponSteadyVisible({ claimable }) {
  return Boolean(claimable)
}

// Whether the pill should currently render. Adds the `suppressed` gate (true
// only while the prompt's own login modal is open).
export function welcomeCouponVisible({ claimable, suppressed }) {
  return !suppressed && couponSteadyVisible({ claimable })
}
